export default __webpack_public_path__ + "static/media/hotel-room.58049ae3.jpg";